export default {
  "content": "<path d=\"M8.876 7.137a5.003 5.003 0 016.25 0L13.876 8.7a3.002 3.002 0 00-3.75 0l-1.25-1.563zM6.332 4.175a8.475 8.475 0 0111.338 0l-1.338 1.487a6.475 6.475 0 00-8.662 0L6.332 4.175zM15.5 14.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.72 11a2 2 0 011.94 1.515l1.5 6A2 2 0 0120.22 21H3.781a2 2 0 01-1.94-2.485l1.5-6A2 2 0 015.281 11h13.437zM3.781 19h16.437l-1.5-6H5.282l-1.5 6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};